<template>
    <div class="footerbg">
      <div class="footer-location">
        <div class="w1200">
          <div class="footer-title">
            {{ $t('contact')}}
          </div>
          <div class="footer-address">
            <span class="sp1">{{iphone}}</span>
            <span class="sp2">{{address}}</span>
          </div>
          <div class="footer-icon">
            <i class="icon3">
              <div class="weixin amn3">
                <img :src="weixincode" alt="">
              </div>
            </i>
          </div>
        </div>
      </div>
      <div class="footerbg-bottom">
        <div class="w1200">
          <div class="btlogo"></div>
          <div class="footerbg-bottom-name">
            <div class="leftdesc" v-html="$t('Companydesc')">
            </div>
            <div class="btnav">
                <a href="javascript:;" class="a1" @click="$router.push({name: 'index'})">{{ $t('index')}}</a>
                <span>/</span>
                <a href="javascript:;" class="a1" @click="$router.push({name: 'about'})">{{ $t('about')}}</a>
                <span>/</span>
                <a href="javascript:;" class="a1" @click="$router.push({name: 'prodlist'})">{{ $t('productCenter')}}</a>
                <span>/</span>
                <a href="javascript:;" class="a1" @click="$router.push({name: 'technology'})">{{ $t('technology')}}</a>
                <span>/</span>
                <a href="javascript:;" class="a1" @click="$router.push({name: 'cooperation'})">{{ $t('cooperation')}}</a>
                <span>/</span>
                <a href="javascript:;" class="a1" @click="$router.push({name: 'environment'})">{{ $t('environment')}}</a>
                <span>/</span>
                <a href="javascript:;" class="a1" @click="$router.push({name: 'newslist'})">{{ $t('newslist')}}</a>
                <span>/</span>
                <a href="javascript:;" class="a1" @click="$router.push({name: 'personnel'})">{{ $t('personnel')}}</a>
            </div>
          </div>
          <div class="footerbg-bottom-desc">
            <div class="left">{{ $t('design')}} COPYRIGHT @ 2012 JINKE Company Limited. All rights reserved.</div>
            <div class="right">
              <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备20005695号-1</a>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'Footer',
  data () {
    return {
      address: '',
      iphone: '',
      weixincode: '',
      companydesc: '',
      icp: ''
    }
  },
  methods: {
  },
  created () {
    const that = this
    // eslint-disable-next-line
    Fetch.post('Api/contact', {
    }).then((res) => {
      that.address = res.result.address
      that.iphone = res.result.mobile
      that.weixincode = res.result.image
      that.icp = res.result.icp
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footerbg{
    height: 274px;
    overflow: visible;
  }
  .footer-location{
    height: 80px;
    background-color: #eff1f2;
  }
  .footer-location .w1200{
    display: flex;
    overflow: visible;
    justify-content: space-between;
    min-height: 80px;
    align-items: center;
  }
  .footer-location .footer-title{
    color: #E40A20;
    font-size: 30px;
    font-weight: bold;
  }
  .footer-location .footer-address{
    flex: 1;
    display: flex;
    align-items: center;
  }
  .footer-location .footer-address .sp1{
    display: block;
    padding-left: 32px;
    margin-left: 46px;
    background:url(../assets/icon1.png) 0 center no-repeat;
    font-size: 14px;
    color: #333;
    width: 500px;
    flex-shrink: 0;
    font-weight: bold;
  }
  .footer-location .footer-address .sp2{
    display: block;
    padding-left: 30px;
    flex-shrink: 0;
    background:url(../assets/icon2.png) 0 center no-repeat;
    font-size: 14px;
    color: #333;
    flex: 1;
    font-weight: bold;
  }
  .footer-icon{
    width: 108px;
    height: 28px;
    border-left: 1px solid #d6d6dc;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .footer-icon .icon3{
    display: block;
    width: 25px;
    height: 20px;
    background:url(../assets/icon3.png) 0 center no-repeat;
    cursor: pointer;
    position: relative;
  }
  .footer-icon .icon3 .weixin{
    position: absolute;
    top: -100px;
    width: 100px;
    height: 0;
    overflow: hidden;
    left: -40px;
    background-color: #fff;
    box-sizing: border-box;
  }
  .footer-icon .icon3 .weixin img{
    width: 90px;
    height: 90px;
    padding: 5px;
  }
  .footer-icon .icon3:hover .weixin{
    height: 100px;
  }
  .footer-icon .icon4{
    display: block;
    width: 25px;
    margin-left: 20px;
    height: 25px;
    background: url(../assets/icon4.png) center center no-repeat;
    border-radius: 50%;
    background-size: 25px 25px;
    cursor: pointer;
  }
  .footerbg-bottom{
    height: 194px;
    background:url(../assets/bottom.png) center 0 no-repeat;
  }
  .btlogo{
    display: block;
    width: 124px;
    height: 32px;
    background: url(../assets/logo.png) 0 0 no-repeat;
    margin-top: 42px;
    margin-left: 3px;
  }
  .footerbg-bottom-name{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    margin-top: 13px;
  }
  .footerbg-bottom-name .leftdesc{
    line-height: 24px;
    height: auto;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
  }
  .footerbg-bottom-name .btnav{
    display: flex;
    line-height: 24px;
  }
  .footerbg-bottom-name .btnav a{
    color: #fff;
    font-size: 14px;
  }
  .footerbg-bottom-name .btnav span{
    color: #fff;
    margin: 0 2px;
    font-size: 14px;
  }
  .footerbg-bottom-desc{
    width: 100%;
    height: 20px;
    display: flex;
    justify-content: space-between;
  }
  .footerbg-bottom-desc .left{
    color: #6F727A;
  }
  .footerbg-bottom-desc .right a{
    color: #6F727A;
  }
</style>



// WEBPACK FOOTER //
// src/pages/footer.vue